import { ConstantsService } from '../../services/constants-service';
import { ObservableRequestService } from '../../services/observable-request.service';
import { RuleParam,RuleParamDataType } from './ruleparamlist/ruleparam.model';
import { Injectable } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class RuleParamService {
    constructor(private requestService: ObservableRequestService) { }
    getRuleParam(): Observable<any> {
        return this.requestService.getRequest(ConstantsService.RULE_PARAM)
            .map(response => {
                return plainToClass(RuleParam, response.arrResult as Object[]);
            });
    };
    getRuleParamDatatype(): Observable<any> {
        return this.requestService.getRequest(ConstantsService.RULE_PARAM_DATATYPE)
            .map(response => {
                return plainToClass(RuleParamDataType, response.arrResult as Object[]);
            });
    };
    addRuleParam(ruleParam: RuleParam): Observable<any> {
        return this.requestService.postRequest(ConstantsService.RULE_PARAM,
            JSON.stringify(ruleParam),
            this.requestService.getJSONContentType());
    }
    
    updateRuleParam(ruleParam: RuleParam): Observable<any> {
        return this.requestService.putRequest(ConstantsService.RULE_PARAM,
            JSON.stringify(ruleParam),
            this.requestService.getJSONContentType());
    }
    deleteRuleParam(id: number): Observable<any> {
        return this.requestService.deleteRequest(
            ConstantsService.RULE_PARAM+"/"+id,null,
            this.requestService.getJSONContentType());
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/rules/rule-param.service.ts